import { render, staticRenderFns } from "./AddBlacklistKeyword.vue?vue&type=template&id=d7dad32c&scoped=true&"
import script from "./AddBlacklistKeyword.vue?vue&type=script&lang=js&"
export * from "./AddBlacklistKeyword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7dad32c",
  null
  
)

export default component.exports